import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getQueryClassicRewards, getQueryDepositPay, getQueryFreeCancellation, getQueryLuxuryOffer } from 'store/router/routerSelectors';
import { updateQuery as updateQueryAction } from 'store/search/searchActions';

import FilterItem from './FilterItem';
import PaymentPolicyFilter from 'components/Filters/Search/PaymentPolicyFilter';

const PaymentPolicyFilterItem = () => {
  const dispatch = useDispatch();
  const isDepositPay = useSelector(getQueryDepositPay);
  const isClassicRewards = useSelector(getQueryClassicRewards);
  const isFreeCancellation = useSelector(getQueryFreeCancellation);
  const isLuxOffer = useSelector(getQueryLuxuryOffer);

  const updateQuery = useCallback(
    (query) => {
      dispatch(updateQueryAction(query));
    },
    [dispatch],
  );

  const clearFilters = useCallback(() => {
    updateQuery({ depositPay: undefined, freeCancellation: undefined, classicRewards: undefined });
  }, [updateQuery]);

  return (
    <FilterItem
      buttonText="Popular Filters"
      isHighlighted={!!(isDepositPay || isFreeCancellation || isClassicRewards || isLuxOffer)}
      clearFilters={clearFilters}
    >
      <PaymentPolicyFilter onChange={updateQuery} />
    </FilterItem>
  );
};

export default PaymentPolicyFilterItem;
